/**
 * 録音前画面 (NSIPS 連携) の dispatcher.
 *
 * user.yakureki_setting.transcription_mode に応じて legacy / streaming の
 * 実装をそのまま呼び出す薄い dispatcher。中の component は自身の mode を
 * 意識しない (transcriptionMode は props で渡さない = 分岐が UI 内に漏れない).
 *
 * 拡張は legacy/ または streaming/ 配下で行う:
 * - legacy/  = Gemini 同期経路 (batch モード) の UI
 * - streaming/ = Chirp Streaming 経路の UI (今後 transcript 即時表示等を拡張)
 */
import { FC } from 'react'
import { Yakureki, YakurekiDetail } from '@/shared/types/yakurekiCore'
import { useMyPharmacyQuery } from '@/features/yakureki/hooks/queries/useMyPharmacyQuery'
import { NSIPSPreRecordingScreen as LegacyPreRecordingScreen } from './legacy/screens/PreRecordingScreen'
import { StreamingNSIPSPreRecordingScreen as StreamingPreRecordingScreen } from './streaming/screens/PreRecordingScreen'

export interface PreRecordingScreenProps {
  patientDetail: YakurekiDetail
  patientList: Yakureki[]
  renderEditableModal: () => React.ReactNode
  pharmacistId?: string
  isMemoOpen?: boolean
}

export const PreRecordingScreen: FC<PreRecordingScreenProps> = (props) => {
  const { transcriptionMode } = useMyPharmacyQuery()
  if (transcriptionMode === 'streaming') {
    return <StreamingPreRecordingScreen {...props} />
  }
  return <LegacyPreRecordingScreen {...props} />
}
